import styled from 'styled-components';
import { layout, media, styledUtils } from 'src/components/base';
import { CardContent, CardActionArea } from '@prisjakt/ui/card';
import { RowCard } from '@prisjakt/ui/card/variants';
import { Column, Row } from '@prisjakt/ui/list/variants';
import { Clickable } from 'src/components/clickable';

export const Card = styled(RowCard)`
  width: 100%;
`;

export const ActionArea = styled(CardActionArea)`
  width: inherit;
`;

export const Main = styled.div`
  width: inherit;
  display: flex;
  ${media.smallOnly`
    flex-direction: column;
  `}
`;

type ImageWrapperProps = {
  $size: string;
};

export const ImageWrapper = styled(CardContent)<ImageWrapperProps>`
  && {
    position: relative;
    height: fit-content;
    width: ${p => p.$size};
    padding: 0;
    margin: ${layout.measurements.spacing100};
  }
`;

export const ColumnWrapper = styled(CardActionArea)`
  padding: ${layout.measurements.spacing100};
`;

export const StoresWrapper = styled(Column)`
  width: 100%;
  padding: ${layout.measurements.spacing100};
`;

export const IconWrapper = styled.div`
  position: absolute;
  z-index: 2;
  padding: ${layout.measurements.spacing150};
  ${media.smallOnly`
    right: ${layout.measurements.spacing100};
  `}
`;

export const RatingWrapper = styled.div`
  margin-top: auto;
  align-self: center;
`;

export const CTAText = styled(Row)`
  && {
    align-items: center;
    text-align: end;
  }

  svg {
    fill: ${p => p.theme.icons.callToAction};
  }
`;

export const CTAWrapper = styled.div`
  margin-top: auto;
`;

export const MissingPlaceHolder = styled(Clickable)`
  width: inherit;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  padding: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  min-height: 47px;
  height: 47px;
  justify-content: center;
  color: ${p => p.theme.text.primary};

  &::after {
    ${styledUtils.overlay()}
    border-radius: 5px;
    pointer-events: none;
    transition: background-color 150ms ease;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.07);
    }
  }
`;
